export default __webpack_public_path__ + "static/media/about-main-sm.bccfe245.jpg";